<template>
    <div class="app-body-container" style="padding-bottom: 30px">

        <!--全面体检-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a examin-card">

                    <!--标题-->
                    <div class="examin-icon">
                        <img src="@/assets/tijian-house.png">
                    </div>
                    <div class="examin-title">欢迎使用Sysale Robot 库存体检</div>
                    <div class="examin-subtitle">时刻了解您的库存健康状况</div>

                    <!--开始检测-->
                    <div class="examin-btn-box" :class="isExaminRun?'is_run':''" @click="start_examin()">
                        <div class="ebb-btn">
                            <div class="ebb-txt">全面<br>检测</div>
                        </div>
                        <div class="ebb-ball"></div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

        <!--体检记录-->
        <el-row class="mg-t-10">
            <el-col :span="24">
                <el-card shadow="hover" class="mycard-a">

                    <!--表格标题-->
                    <div class="mycard-title" style="margin-bottom: 20px">
                        体检记录
                        <el-popover placement="right" width="360" trigger="hover">
                            <div>
                                显示近30天库存体检记录
                            </div>
                            <i class="iconfont iconft-question mycard-title-icon" slot="reference"></i>
                        </el-popover>
                    </div>

                    <!--表格、分页-->
                    <el-table :data="main$data" v-loading="main$loading" size="medium">
                        <el-table-column prop="checkTime" label="时间" width="220" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="goodsNumber" label="检测商品数" width="220" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="errorNumber" label="库存量异常商品数" width="240" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="expirationNumber" label="临期风险商品数" width="240" align="center" header-align="center"> </el-table-column>
                        <el-table-column prop="lackNumber" label="缺货商品数" width="240" align="center" header-align="center"> </el-table-column>
                        <el-table-column align="center" header-align="center">
                            <template slot-scope="scope">
                                <el-button type="text" style="color: #29CF87" @click="table_detail(scope.row)">查看结果</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="margin: 14px">
                        <el-pagination style="float: right"
                                       background
                                       layout="total, sizes, prev, pager, next"
                                       :page-size="main$page_size"
                                       :current-page="main$curr_page"
                                       :total="main$total"
                                        @current-change="handlePageChange"></el-pagination>
                        <div style="clear: both;"></div>
                    </div>

                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            isExaminRun: false,
            // 表格
            main$page_size: 10,
            main$curr_page: 1,
            main$loading: false,
            main$total: 0,
            main$data: []
        }
    },
    methods: {
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/stock/check/getCheckList'), {
                page: self.main$curr_page,
                rows: self.main$page_size
            },{xPostType:'form'} ).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$total = 0;
                    self.main$data = [];
                }
                else {
                    self.main$total = res.data.total;
                    self.main$data = res.data.rows;
                }
            });
        },
        handlePageChange: function (val) {
            this.main$curr_page = val;
            this.fetchData();
        },
        table_detail: function (row) {
            this.xTo({path: '/inventory/examination-complete', query: {eid: row.id}});
        },
        // 开始检测
        start_examin: function () {
            var self = this;

            if (self.isExaminRun)
                return;

            self.isExaminRun = true

            self.xFetch.post(self.xApi('/robot/stock/check/startCheck'), {}).then(function (res) {
                if (res.data.code != '00') {
                    self.isExaminRun = false
                    self.xEui.alert_error('',res.data.text)
                    return
                }
                let eid = res.data.data;
                let fnCheck = function(){
                    setTimeout(function(){
                        // 体检结果 - START
                        self.xFetch.post(self.xApi('/robot/stock/check/getCheckDetails'), {
                            id: eid
                        }, {xPostType: 'form'}).then(function (chkRes) {
                            if(chkRes.data.data){
                                // 完成
                                self.xTo({path: '/inventory/examination-complete', query: {eid: eid}});
                            }
                            else{
                                // 未完成
                                fnCheck();
                            }
                        });
                        // 体检结果 - END
                    },3000)
                }
                fnCheck();
            });
        }
    },
    created: function(){
      var self = this;

      // 初始化状态
      self.isExaminRun = false

      // 表格数据
      self.fetchData();
    },
    // keep-alive事件
    activated:function(){
        var self = this;

        // 初始化状态
        self.isExaminRun = false

        // 表格数据
        self.fetchData();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mycard-title{ color: #29CF87 }
    .mycard-title .mycard-title-icon{ font-size: 18px;position: relative;top: -5px;color: #909399 }
    /*examin-card*/
    .examin-card{ background: #29CF87;text-align: center;padding-top: 20px}
    .examin-card .examin-icon{ }
    .examin-card .examin-icon img{ width: 80px }
    .examin-card .examin-title{ font-size: 30px;color: #fff;text-align: center;margin-top: 22px }
    .examin-card .examin-subtitle{ font-size: 18px;color: #fff ;text-align: center;margin-top: 22px;}
    /*examin-btn-box*/
    .examin-btn-box{
        width: 180px;
        height: 180px;
        display: inline-block;
        border: 1px solid #b8e986;
        border-radius: 50%;
        margin: 20px 0;
        cursor: pointer;
        position: relative;
    }
    .examin-btn-box .ebb-btn{
        margin: 25px;
        width: 126px;
        height: 126px;
        border: 2px solid #7ed321;
        border-radius: 50%;
        background: #fff;
        position: relative;
    }
    .examin-btn-box .ebb-btn:before{
        display: table;
        content: '';
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        box-shadow: 0px 0px 20px 5px rgba(0,0,0,0.3);
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
    }
    .examin-btn-box:hover .ebb-btn:before{
        opacity: 1;
    }
    .examin-btn-box .ebb-btn .ebb-txt{color: #29cf87;font-size: 28px;line-height: 32px;padding-top: 30px}
    .examin-btn-box .ebb-ball{
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        transform-origin: 50% 50%;
        animation: 1.8s ebb_swing cubic-bezier(.47,.5,0,.99) infinite;
        animation-play-state:paused;
        opacity: 0;
    }
    .examin-btn-box .ebb-ball:before{
        content: '';
        display: table;
        position: absolute;
        left: 50%;
        margin-left: -5px;
        top: -5px;
        height: 10px;
        width: 10px;
        background: #fff;
        border-radius: 50%;
    }
    .examin-btn-box.is_run{ cursor: default }
    .examin-btn-box.is_run .ebb-btn:before{ opacity: 1; }
    .examin-btn-box.is_run .ebb-ball{ animation-play-state:running;opacity: 1; }
    @keyframes ebb_swing {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
</style>



// WEBPACK FOOTER //
// src/views/inventory/examination.vue